import Vue from 'vue';

class AlertCenter {
  error(txt, props = {}) {
    const position = 'bottom-right';
    const duration = 5000;

    const vm = new Vue({
      render: h => h('div'),
      mounted() {
        this.$oruga.notification.open({
          ...props,
          duration,
          message: txt,
          variant: 'danger',
          position,
          actionText: null,
        });
      }
    }).$mount();

    document.body.appendChild(vm.$el);
    setTimeout(() => {
      vm.$destroy();
      if (vm.$el.parentNode) vm.$el.parentNode.removeChild(vm.$el);
    }, duration + 100);
  }

  info(txt, props = {}) {
    const position = 'top';
    const duration = 2000;

    const vm = new Vue({
      render: h => h('div'),
      mounted() {
        this.$oruga.notification.open({
          ...props,
          duration,
          message: txt,
          variant: 'success',
          position,
          actionText: null,
        });
      }
    }).$mount();

    document.body.appendChild(vm.$el);
    setTimeout(() => {
      vm.$destroy();
      if (vm.$el.parentNode) vm.$el.parentNode.removeChild(vm.$el);
    }, duration + 100);

  }
}

export const alertCenter = new AlertCenter();

export const AlertMixin = {
  methods: {
    $alertError(txt, props) {
      return alertCenter.error(txt, props);
    },
    $alertSuccess(txt, props) {
      return alertCenter.info(txt, props);
    }
  },
  async beforeRouteLeave(to, from, next) {
    next();
  }
};

window['alertCenter'] = alertCenter;
